import classnames from "classnames";
import React from "react";
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink } from "reactstrap";


class NavSelector extends React.Component {
      
    state = {
        navPills: 1,
        user: {},
        canSave: true
    }

    render() {

        const navPill = this.props.navPill;
 
        return (
            <>

                <Nav className="mb-4 nav-fill flex-column flex-sm-row" id="tabs-text" pills role="tablist" >
                
                    <NavItem>
                        <NavLink
                            aria-selected={navPill === 1}
                            className={classnames("mb-sm-3 mb-md-0", {active: navPill === 1})}
                            onClick={e => this.props.toggleNavs(e, 1)}
                            href="#pablo"
                            role="tab"
                        >
                            Log Time
                        </NavLink>
                    </NavItem>

                    <NavItem>
                        <NavLink
                            aria-selected={navPill === 2}
                            className={classnames("mb-sm-3 mb-md-0", {active: navPill === 2})}
                            onClick={e => this.props.toggleNavs(e, 2)}
                            href="#pablo"
                            role="tab"
                        >
                            View All Entries
                        </NavLink>
                    </NavItem>
                 
                </Nav>

            </>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_projects: state.projects.app_projects,

    };
};
  
export default connect(mapStateToProps, '')(NavSelector);